import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import SelectAjax from "../../components/form/SelectAjax";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import STRINGS from './../../data/language/language';
import Random from "../../utils/strings/Random";
import {FormDataToJson} from '../../utils/json/Json';
import Dialog from '../../components/alert/Dialog';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import PAGES from '../../config/Pages';
import EmptyList from '../../components/emptyList/EmptyList';


const itemIdPrefix = "item-exercicio-";
const URL_DETALHE_ITEM = WS.clientes.detalhe;

class PageCliente extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      detalhe: props.detalhe,
      showStatus: 1
    }

    this.callCliente = this.callCliente.bind(this);
    this.callPagamentos = this.callPagamentos.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  callPagamentos(data){
    this.setState({
      showStatus: 2,
      detalhe: {items: data.item.pagamentos}
    });
  }

  callCliente(id){
    const {atencao,erroDetalhe} = this.state.strings;

    const _self = this;

    Requisitions({
      url:URL_DETALHE_ITEM,
      data:{ id },
      sucess:function(data){
        var msg;

        if(data.status){
          _self.callPagamentos(data);
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroDetalhe
        });
      }
    });
  }

  render (){
    let lista;

    if(this.state.showStatus == 1){
      lista = this.state.detalhe.items.map((value, i) =>
        <div className='item-relatorio' key={i}>
            <a href="#" onClick={(e)=>{
              e.preventDefault();
              this.callCliente(value.id);
            }}><div>Cliente: {value.nome}</div></a>
        </div>
        );
    }else{
      lista = this.state.detalhe.items.map((value, i) =>
      <div className='item-relatorio' key={i}>
          <div className='item-relatorio__title'>{value.data}</div>
          <div>Tipo: {value.tipo_adesao}</div>
          <div>Valor: {value.valor}</div>
      </div>
      );

      if(this.state.detalhe.items.length<=0){
        lista = <EmptyList />;
      }
    }

    return (
      <div>
        <MainTitle title='Selecione o cliente' />
        {lista}
      </div>
    );
  }
}

export default PageCliente;



// WEBPACK FOOTER //
// ./src/classes/relatorios/PageCliente.js